import React, { useContext } from 'react';
import MenuItemReady from './MenuItemReady.js';
import { Context } from '../../../store/Store.js';
import MenuItemLoading from './MenuItemLoading.js';
import { messageManager } from '../../System/messageManager/messageManager.js';
import './GeneratedDocumentsMenuItems.scss';
import { DOWNLOAD_REPORTS } from '../../../static/constants.js';
import GeneralEmptyState from '../../reusable/EmptyState/GeneralEmptyState/GeneralEmptyState.js';
import { useNameConventions } from '../../../contexts/nameConventionsContext.js';

const GeneratedDocumentsMenuItems = () => {
  const [state] = useContext(Context);
  const { nameConventions } = useNameConventions();

  if (!state.generatedDocuments || state.generatedDocuments.length === 0)
    return (
      <div style={{width: '350px'}}>
        <GeneralEmptyState
          alt={DOWNLOAD_REPORTS.alt}
          src={DOWNLOAD_REPORTS.source}
          message={messageManager(nameConventions).DOCUMENT_GENERATOR.NO_GENERATED_DOCUMENTS}
          showButton={false}
        />
      </div>
    );

  return (
    <ul>
      {state.generatedDocuments.map((document) => {
        return document.ready ? (
          <MenuItemReady key={`${document.documentName}_${document.generationDate}`} document={document} />
        ) : (
          <MenuItemLoading key={`${document.documentName}_${document.generationDate}`} document={document} />
        );
      })}
    </ul>
  );
};

export default GeneratedDocumentsMenuItems;
